<template>
  <div class="guide-tree-item-card" @click="goLive(treeNode)">
    <div class="card-top" :class="{activity: treeNode.activityPlay}">
      <!--      直播与回放的icon-->
      <template
        v-if="
          treeNode.studyResourceType === 2 &&
          treeNode.resourceList &&
          treeNode.resourceList.length > 0 &&
          treeNode.resourceList[0].clientReplayStatus === 2
        "
      >
        <img src="../../assets/img/learningGuidePage/live_icon.png" alt />
      </template>
      <template
        v-if="
          treeNode.studyResourceType === 3 && treeNode.resourceList && treeNode.resourceList.length > 0 ||
          (treeNode.studyResourceType === 2 &&
            treeNode.resourceList &&
            treeNode.resourceList.length > 0 &&
            treeNode.resourceList[0].clientReplayStatus !== 2)
        "
      >
        <img src="../../assets/img/components/courseDetail/record_icon.png" alt />
      </template>
      <template
        v-if="
          treeNode.studyResourceType === 7 &&
          treeNode.resourceList &&
          treeNode.resourceList.length > 0
        "
      >
        <img
          src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/courseDetail/exam_icon.png"
          alt
        />
      </template>
      <!-- title name-->
      <div class="item-title">
        <i v-if="treeNode.name.substr(0, 1) == '【'" class="title-special-processing-small" />
        {{ treeNode.name }}
      </div>
    </div>

    <div class="card-bottom" v-if="!(treeNode.studyResourceType === 0)">
      <!--      直播-->
      <!--      // 回放
      // 直播结束，生成回放，提供回放，可显示回放，才跳转回放页-->
      <template
        v-if="
          treeNode.studyResourceType === 2 &&
          treeNode.resourceList &&
          treeNode.resourceList.length > 0
        "
      >
        <!-- 直播与回放的标签 -->

        <template v-if="treeNode.resourceList[0].clientReplayStatus===5">
          <div class="bottom-item">
            <TagComponent text="回放" color="yellow-no-bg" />
          </div>
        </template>
        <template
          v-else-if="treeNode.resourceList[0].clientReplayStatus === 1 || treeNode.resourceList[0].clientReplayStatus === 2"
        >
          <div class="bottom-item">
            <TagComponent text="直播" color="yellow-no-bg" />
          </div>
          <div
            class="bottom-item"
          >{{ initDate(treeNode.resourceList[0].startTime, treeNode.resourceList[0].endTime) }}</div>
        </template>

        <!-- 回放状态 -->
        <span
          v-if="judgeStatus('liveText')"
          class="status-text bottom-item"
        >{{ judgeStatus('liveText') }}</span>

        <!-- 学习进度 回放显示学习进度 -->
        <span
          v-if="progress && treeNode.resourceList[0].clientReplayStatus === 5"
          class="bottom-item"
        >
          已学
          <span class="yellow-text">{{ (progress * 100).toFixed(0) }}%</span>
        </span>
        <!-- 直播显示进入课堂按钮 -->
        <span v-if="treeNode.resourceList[0].clientReplayStatus === 2" class="enter-btn">进入课堂</span>
      </template>

      <template v-if="treeNode.studyResourceType === 3">
        <!-- <div class="live-icon">录播</div> -->
        <span v-if="progress">
          已学
          <span class="yellow-text">{{ (progress * 100).toFixed(0) }}%</span>
        </span>
      </template>
      <!-- 播放时长 -->
      <template v-if="judgeStatus('liveRecord')||treeNode.studyResourceType === 3">
        <span class="videoDuration">{{ getVideoDuration(treeNode.resourceList[0].duration)}}</span>
      </template>

      <div class="examBottomArea" v-if="treeNode.studyResourceType === 7">
        <div class="examBottomArea_type">考试</div>
        <div class="examBottomArea_line"></div>
        <div class="examBottomArea_time">{{rawExamStr(treeNode.resourceList[0], 'time')}}</div>
        <div class="examBottomArea_line"></div>
        <div
          class="examBottomArea_status"
        >{{rawExamStr(treeNode.resourceList[0], 'status', examStatusMap[treeNode.id])}}</div>
      </div>
    </div>

    <!-- 展开收起标签-->
    <div class="arrow-icon" v-if="showIcon">
      <template v-if="expand">
        <van-icon name="arrow-up" />
      </template>
      <template v-else>
        <van-icon name="arrow-down" />
      </template>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
// eslint-disable-next-line import/extensions
import TagComponent from '@/components/commonComponents/TagComponent';
import { setVideoDuration } from '@/utils/tools';

export default {
  components: { TagComponent },
  props: {
    treeNode: {
      type: Object,
      default: () => ({}),
    },
    examStatusMap: {
      type: Object,
      default: () => ({}),
    },
    progress: {
      type: [String, Number],
      default: '',
    },
    learnData: {
      type: Object,
      default: () => ({}),
    },
    expand: {
      type: Boolean,
      default: false,
    },
    catalogInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    // 是否展示折叠、收起ICON
    showIcon() {
      // 如果是目录, 并且有子节点,则展示icon
      const { type, children } = this.treeNode;
      const flag = children?.every(item => item.studyResourceType === 4);
      return type === 1 && children && children?.length && !flag;
    },
  },
  methods: {
    rawExamStr(item, type, status) {
      if (type === 'time') {
        return (
          item.startTime
            .slice(0, 10)
            .split('-')
            .join('.') +
          '-' +
          item.endTime
            .slice(0, 10)
            .split('-')
            .join('.')
        );
      }

      if (type === 'status') {
        var map = {
          '1': '未开始',
          '2': '进行中',
          '3': '已结束',
        };
        console.log('??..??', this.examStatusMap, item.resourceStatus);
        return status == 1 ? '已作答' : map[item.resourceStatus + ''];
      }
    },
    // 跳转直播页
    async goLive(treeNode) {
      if (treeNode.type === 1) {
        return;
      }
      // 是否可以播放
      const liveRecord = this.judgeStatus('liveRecord');
      if (
        treeNode.studyResourceType === 2 &&
        treeNode.resourceList &&
        treeNode.resourceList.length > 0 &&
        treeNode.resourceList[0].clientReplayStatus === 2
      ) {
        const { resourceSource = 1 } = treeNode.resourceList[0]; // 1 CC 2 百家云
        if (resourceSource === 2) {
          this.$router.push({
            path: '/liveBJY',
            query: {
              roomId: treeNode.resourceList[0].roomId,
              courseId: this.learnData.productId,
              liveId: treeNode.resourceList[0].resourceId,
              chapterId: treeNode.id,
              liveName: treeNode.name,
              templateType: treeNode.resourceList[0].templateType,
            },
          });
          return;
        }
        // 区分是三分屏 或者大视频
        const path =
          treeNode.resourceList[0].templateType === 4 || treeNode.resourceList[0].templateType === 5
            ? '/threeScreenLive'
            : '/live';
        this.$router.push({
          path,
          query: {
            roomId: treeNode.resourceList[0].roomId,
            courseId: this.learnData.productId,
            liveId: treeNode.resourceList[0].resourceId,
            chapterId: treeNode.id,
            liveName: treeNode.name,
          },
        });
      }
      if (
        treeNode.studyResourceType === 2 &&
        treeNode.resourceList &&
        treeNode.resourceList.length > 0 &&
        treeNode.resourceList[0].clientReplayStatus === 5
      ) {
        const { resourceSource = 1 } = treeNode.resourceList[0]; // 1 CC 2 百家云
        if (resourceSource === 2) {
          // this.$toast('暂不支持网页播放，请在APP内观看回放');
          this.$emit('openApp');
          return;
        }
        this.$router.push({
          name: 'playback',
          params: {
            courseId: this.learnData.productId,
            chapterId: treeNode.id,
            resourceId: treeNode.resourceList[0].resourceId,
            openCourseId: this.$route.query.catalogId || this.catalogInfo.openCourseId,
            vid: treeNode.resourceList[0].roomId,
          },
        });
      } else if (
        liveRecord ||
        (treeNode.studyResourceType === 3 &&
          treeNode.resourceList &&
          treeNode.resourceList.length > 0)
      ) {
        const vid =
          treeNode.studyResourceType === 3
            ? treeNode.resourceList[0].vid
            : treeNode.resourceList[0].roomId;
        // studyResourceType === 3 为录播
        // resourceSource 1 CC 2 百家云
        // this.$parent.openDownLoadDialog();
        sessionStorage.setItem('guideProductName', this.learnData?.productName);
        this.$router.replace({
          name: 'record',
          params: {
            chapterId: treeNode.id,
            resourceId: treeNode.resourceList[0].resourceId,
            openCourseId: this.$route.query.catalogId || this.catalogInfo.openCourseId,
            vid,
            type: treeNode.resourceList[0].resourceSource || 1,
            duration: treeNode.resourceList[0].duration || 0,
          },
        });
      } else if (
        treeNode.studyResourceType === 7 &&
        treeNode.resourceList &&
        treeNode.resourceList.length > 0
      ) {
        const { resourceStatus, resourceId, startTime } = treeNode.resourceList[0];

        console.log("examsee", resourceId, treeNode.id, this.examStatusMap[treeNode.id], resourceStatus)

        // 章节考试
        if (this.examStatusMap[treeNode.id] == 1) {
          // 考试报告
          window.location.href = `${
            window.location.origin
          }/mockExam/answerReport?examId=${resourceId}&THIRD_SESSION=${localStorage.getItem(
            'accessToken',
          )}`;
        } else {
          if (resourceStatus == 1) {
            const [year, month, day] = startTime.slice(0, 10).split('-');
            this.$toast(`该考试将于${year}年${month}月${day}日开始`);
          }
          if (resourceStatus == 2) {
            const { skuId, productId } = this.learnData;

            const url = `${
              window.location.origin
            }/mockExam/paper?examId=${resourceId}&examSource=2&productId=${productId}&productSkuId=${skuId}&THIRD_SESSION=${localStorage.getItem(
              'accessToken',
            )}`;
            // wx.navigateTo({
            //   url: `/subPackages/webView/webView?url=${h5LinkAddParams(url)}`,
            // });
            window.location.href = url;
          }
          if (resourceStatus == 3) {
            this.$toast('考试已结束');
          }
        }
      }
    },
    // 格式化时间
    initDate(start, end) {
      return `${moment(start).format('YYYY.MM.DD HH:mm')}-${moment(end).format('HH:mm')}`;
    },
    // eslint-disable-next-line consistent-return
    judgeStatus(val) {
      // 直播结束，生成回放，提供回放，可显示回放，才跳转回放页
      const { resourceType, clientReplayStatus } = this.treeNode.resourceList[0];
      //  判断可以直播回放
      if (val === 'liveRecord') {
        return (resourceType === 2 && clientReplayStatus === 5) || resourceType === 3;
      }
      if (val === 'liveText') {
        const statusJson = {
          1: '未开始',
          3: '暂无回放',
          4: '回放生成中',
        };
        return statusJson[clientReplayStatus] ? statusJson[clientReplayStatus] : '';
      }
    },
    getVideoDuration(data) {
      const duration = setVideoDuration(data);
      return duration;
    },
  },
};
</script>

<style scoped lang="scss">
.examBottomArea {
  display: flex;
  align-items: center;
  gap: 14px;
  height: 36px;

  .examBottomArea_type {
    /* border: 1px solid #FF6C02; */
    color: #ff6c02;
    padding: 0 15px;
    border-radius: 4px;
    height: 31px;
    font-size: 22px;
    display: flex;
    align-items: center;
    background-color: rgba(255, 182, 129, 0.13);
  }

  .examBottomArea_time {
    height: 36px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 25px;
    color: #999999;
    line-height: 36px;
  }

  .examBottomArea_status {
    height: 36px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 25px;
    color: #999999;
    line-height: 36px;
  }

  .examBottomArea_line {
    width: 2px;
    height: 29px;
    background: #999999;
  }
}

.leaf-node {
  .guide-tree-item-card {
    flex-direction: column;
    justify-content: center;
    min-height: 160px;
  }
}

.activity {
  .item-title {
    color: $theme_color;
  }
}

.guide-tree-item-card {
  display: flex;
  width: 100%;

  .yellow-text {
    color: #ff6c02;
  }

  .enter-btn {
    display: flex;
    align-items: center;
    height: 43px;
    margin-left: auto;
    padding: 0 20px;
    color: white;
    background: #ff6c02;
    border-radius: 24px;
  }

  .card-top {
    display: flex;
    align-items: center;
    height: 36px;
    margin-top: 22px;
    margin-bottom: 12px;

    img {
      width: 29px;
      height: 29px;
      margin-right: 14px;
    }
  }

  .card-bottom {
    position: relative;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    height: 48px;
    margin-bottom: 10px;
    margin-left: 43px;

    .card-live-time {
      color: #a5a5a5;
      font-weight: 400;
      font-size: 25px;
    }

    .status-text {
      display: flex;
      align-items: center;
    }

    .bottom-item {
      display: flex;
      align-items: center;

      &::after {
        display: inline-block;
        width: 2px;
        height: 30px;
        margin: 0 14px;
        background: #f5f5f6;
        content: '';
      }
      &:last-child::after {
        width: 0;
        margin: 0;
      }
    }
    .videoDuration {
      position: absolute;
      right: 0;
      bottom: 10px;
    }
  }

  .item-title {
    overflow: hidden;
    line-height: 32px;
    white-space: nowrap;
    text-overflow: ellipsis;
    word-break: keep-all;
  }

  .arrow-icon {
    flex: 1;
    align-self: center;
    text-align: right;

    i {
      color: #808080;
      font-size: 24px;
    }
  }

  .live-time {
    flex: 1;
    margin-left: 16px;
    line-height: 36px;
    white-space: nowrap;
    text-align: right;
  }

  .tree-node-title {
    font-size: 24px;
    border-bottom: 1.1px solid #f5f5f5;

    .item-title {
      line-height: 36px;
    }
  }

  &.leaf-node {
    .tree-node-title {
      color: #808080;
    }
  }
}

.tree-node-branch {
  &0 {
    .card-top {
      height: 120px;
      margin: 0;
    }
    .item-title {
      color: black;
      font-weight: bold;
      font-size: 34px;
      line-height: 38px;
    }
  }

  &1 {
    .card-top {
      height: 120px;
      margin: 0;
    }
    .item-title {
      color: #444;
      font-weight: bold;
      font-size: 28px;
      line-height: 32px;
    }
  }

  &2 {
    .card-top {
      height: 120px;
      margin: 0;
    }

    .item-title {
      color: #808080;
      font-size: 28px;
      line-height: 32px;
    }
  }
}
</style>
